<div class="surface-card p-4 shadow-2 border-round">

    <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
        <div class="flex justify-end md:justify-center">
            <span class="text-xl font-medium text-2000 font-['Poppins']" style="color: #6c092c">SCORTE<span *ngIf="lockMagazzino != null && this.filterMagazzino != null"> {{ this.filterMagazzino.codice}}</span></span>
        </div>

        <div class="flex justify-end md:justify-center" style="margin-left: 1em">
            <button pButton type="button" icon="pi pi-download" class="p-button-rounded mr-2 p-button-outlined" tooltipPosition="top" pTooltip="Scarica lista movimentazioni" (click)="downloadDataAsXlsx()" style="background-color: rgb(148, 121, 206); color: white;"></button>

        </div>
        <div style="flex-grow: 1"></div>

        <div class="flex justify-end md:justify-end form_row" style="align-items: center">
            <div  class="form_row_item" *ngIf="(!lockMagazzino) && (!lockImpresa)">
                <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='optionsImpresa' [(ngModel)]="filterImpresa" placeholder="impresa" (onChange)="updateFilterAzienda()"></p-dropdown>
            </div>
            <div class="form_row_item" *ngIf="!lockMagazzino">
                <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='optionsMagazzino' [(ngModel)]="filterMagazzino" placeholder="magazzino" (onChange)="updateFiltered()" ></p-dropdown>
            </div>
            <div class="form_row_item">
                <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='optionsModelli' [(ngModel)]="filterModello" placeholder="dispositivo" (onChange)="updateFiltered()"></p-dropdown>
            </div>
            <div class="form_row_item">
                <p-dropdown styleClass="form_select_mid" appendTo="body" [options]='optionsQuotaLessThan' [(ngModel)]="filterQuotaLessThan" placeholder="sotto quota" (onChange)="updateFiltered()"></p-dropdown>
            </div>
            <div class="form_row_item" style="align-items: center">
                <form class="flex align-items-center gap-1">
                    <p-checkbox [(ngModel)]="filterHasAny" [binary]="true" inputId="filterHasAny" (click)="updateFiltered()" name="filterHasAny"></p-checkbox>
                    <label for="filterHasAny">solo riforniti</label>
                </form>
            </div>
        </div>

    </div>

    <div fxFlex="95%">

        <p-table #comuniDT styleClass="p-datatable-sm" [value]="filteredScorte" dataKey="id"
                 [selectionPageOnly]="true" [rowHover]="true" [rows]="30" [showCurrentPageReport]="true"
                 [rowsPerPageOptions]="[30,50,100]" [loading]="!dataReady" responsiveLayout="stack" [paginator]="true"
                 currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                 [globalFilterFields]="['','']" [sortField]="'codice'" [sortOrder]="1">

            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="magazzino.codice">
                        <div class="flex justify-content-between align-items-center">
                            Magazzino
                            <p-sortIcon field="magazzino.codice"></p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="impresa.ragioneSociale">
                        <div class="flex justify-content-between align-items-center">
                            Impresa
                            <p-sortIcon field="impresa.ragioneSociale"></p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="modello.nmu">
                        <div class="flex justify-content-between align-items-center">
                            Modello
                            <p-sortIcon field="modello.nmu"></p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="total_max">
                        <div class="flex justify-content-between align-items-center">
                            Scorta massima
                            <p-sortIcon field="total_max"></p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="total_current">
                        <div class="flex justify-content-between align-items-center">
                            Scorta corrente
                            <p-sortIcon field="total_current"></p-sortIcon>
                        </div>
                    </th>
                    <th pSortableColumn="left_perc">
                        <div class="flex justify-content-between align-items-center">
                            Livello
                            <p-sortIcon field="left_perc"></p-sortIcon>
                        </div>
                    </th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row>
                <tr>

                    <td>
                        <span class="text-lowercase">
                        {{row.magazzino.codice}}
                        </span>
                    </td>
                    <td>
                        <span class="text-lowercase">
                            <p-tag
                                [style]="{
                                  'background-color': '#326F6F' ,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                }"
                            >{{ row.impresa.ragioneSociale }}</p-tag>

                        </span>
                    </td>
                    <td>
                        <span class="text-lowercase">
                            {{ row.modello.nmu }}:
                            {{ row.modello.descrizione }}
                        </span>
                    </td>
                    <td><span class="text-lowercase" [ngSwitch]="row.total_max != null && row.total_max != 0">
                        <span *ngSwitchCase="true">
                            {{ row.total_max }}
                        </span>
                    </span></td>
                    <td><span class="text-lowercase">
                            {{ row.total_current }}
                    </span></td>
                    <td><span class="text-lowercase" [ngSwitch]="row.total_max != null">
                        <span *ngSwitchCase="true">

                            <p-tag
                                [style]="{
                                  'background-color': BANDS_COLORS[row.left_band_id] ?? BANDS_FALLBACK,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                }"
                            >{{ row.left_perc }}%</p-tag>


                        </span>
                    </span></td>


                </tr>
            </ng-template>

        </p-table>

    </div>
</div>

<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" [breakpoints]="{'960px': '75vw', '640px': '100vw'}"></p-confirmDialog>

<p-toast position="top-center"></p-toast>
